import { IcStatusTag } from "@ukic/react";
import type { Device } from "../api";
import { modeTagStatus, statusLabel, statusTagStatus } from "../format";

/** Device lifecycle/liveness status tag (Active / Offline / Pending / Disabled). */
export function DeviceStatusTag({ device }: { device: Device }) {
  return (
    <IcStatusTag
      label={statusLabel(device.status, device.last_seen)}
      status={statusTagStatus(device.status, device.last_seen)}
    />
  );
}

/** Device mode tag (idle / live / capture). */
export function ModeTag({ mode }: { mode: Device["mode"] }) {
  const label = mode ? mode.charAt(0).toUpperCase() + mode.slice(1) : "Unknown";
  return <IcStatusTag label={label} status={modeTagStatus(mode)} />;
}
